module.exports = __webpack_public_path__ + "media/images/desktop/writer-offering-idea-plot-selection-flow-405f85252de93de57a4bcfc5d1705f2c.png";